import { toInteger } from 'lodash';
import React, { useEffect, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { LinearGradient } from '@/utils/draw-svg-kit/linear-gradient';
import { getLayerInnerStyle, getLayerWrapStyle } from '@/utils/layer-kit';
import type { IImageTransform, ILayerProps, IQrCodeLayerProps, IRenderLayerEvent } from '@/version-types';
import { convertToQRCodeInfo, getDrawID } from '../utils/converter';

// TODO: 这些逻辑是否可以合并到 getLayerInnerStyle
const getInnerStyle = ({
    width,
    height,
    imageTransform,
}: {
    width: number;
    height: number;
    imageTransform: IImageTransform;
}) => {
    const {
        widthRatio,
        heightRatio,
        flipH,
        flipV,
        offsetX: offsetXRatio,
        offsetY: offsetYRatio,
        scale,
    } = imageTransform;
    const originImgWidth = toInteger(width * widthRatio);
    const originImgHeight = toInteger(height * heightRatio);
    const offsetX = toInteger(offsetXRatio * originImgWidth * scale);
    const offsetY = toInteger(offsetYRatio * originImgHeight * scale);

    const innerStyle = getLayerInnerStyle(originImgWidth, originImgHeight, offsetX, offsetY, scale, flipH, flipV);

    return innerStyle;
};

const QrCodeLayerContent: React.FC<
    {
        layer: ILayerProps;
        normalIcon?: boolean;
    } & IRenderLayerEvent
> = ({ layer, normalIcon = false, renderEnd }) => {
    const { opacity, width, height } = layer;
    const { text, fill, stroke, strokeGradient, imageTransform } = layer.data as IQrCodeLayerProps;

    const gradientId = `STROKE_${uuid()}`;

    const svgStyle: React.CSSProperties = {
        stroke: strokeGradient ? `url(#${gradientId})` : stroke,
    };

    const [qrCodePath, setQrCodePath] = useState({ path: '', size: 0 });

    useEffect(() => {
        if (qrCodePath.path) {
            renderEnd?.();
        }
    }, [qrCodePath, renderEnd]);

    useEffect(() => {
        convertToQRCodeInfo(text).then((res) => {
            setQrCodePath(res);
        });
    }, [text]);

    return (
        <div style={getLayerWrapStyle(opacity)}>
            {/* ATTENTION: 这里将 flip 并入 innerStyle，后续如果要统一所有图层的 flip ，应该需要再剥离为独立的一层 */}
            <div style={getInnerStyle({ width, height, imageTransform })}>
                <svg
                    {...(!normalIcon && { 'data-draw-id': getDrawID(layer.id) })}
                    width={width}
                    height={height}
                    viewBox={`0 0 ${qrCodePath.size} ${qrCodePath.size}`}
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    preserveAspectRatio="none"
                    shapeRendering="crispEdges"
                    style={{ display: 'block' }}
                >
                    {strokeGradient ? (
                        <defs>
                            {strokeGradient ? (
                                <LinearGradient
                                    id={gradientId}
                                    width={qrCodePath.size}
                                    height={qrCodePath.size}
                                    linearGradient={strokeGradient}
                                />
                            ) : null}
                        </defs>
                    ) : null}
                    {/* TODO: 这个纯色背景是否可以直接使用 svg 背景色来满足 */}
                    <rect x={0} y={0} rx={0} ry={0} width={qrCodePath.size} height={qrCodePath.size} fill={fill} />
                    <path d={qrCodePath.path} style={svgStyle} />
                </svg>
            </div>
        </div>
    );
};

export default React.memo(QrCodeLayerContent);
